import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { InputField } from "../../../../Components/formElements/InputField";

const MaterialListQualityCheckModal = ({
  show,
  onHide,
  qcType,
  rowData,
  onSaveQualityCheck,
  editMode = false,
}) => {
  const [qcForm, setQcForm] = useState({
    packagingCondition: "",
    physicalDamage: "",
    quantityVerified: "",
    inspectionRemarks: "",
    modelMatch: "",
    brandMatch: "",
    sizeGradeMatch: "",
    technicalParamsOk: "",
  });



useEffect(() => {
  if (show && rowData) {
    // console.log("Modal Ope rowData:", rowData);

    const qcDetails =
      rowData?.qualityCheckDetails?.find(
        (qc) => qc.qcType === qcType
      ) || {};

    setQcForm({
      grnItemNr:qcDetails.grnItemNr || "",
      packagingCondition: qcDetails.packagingCondition || "",
      physicalDamage: qcDetails.physicalDamage || "",
      quantityVerified: qcDetails.quantityVerified || "",
      inspectionRemarks: qcDetails.inspectionRemarks || "",

      modelMatch: qcDetails.modelMatch || "",
      brandMatch: qcDetails.brandMatch || "",
      sizeGradeMatch: qcDetails.sizeGradeMatch || "",
      technicalParamsOk: qcDetails.technicalParamsOk || "",
    });
  }
}, [show, rowData, qcType]);


  /* ---------------- ON CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setQcForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

// eslint-disable-next-line
  const handleSave = () => {
  const payload = {
    qcType,
    grnItemNr: rowData?.srno,
    materialCode: rowData?.materialCode,
    materialDescription: rowData?.materialDescription,
    ...qcForm,
  };

  onSaveQualityCheck(payload);
  onHide();
};

  /* ---------------- UI ---------------- */
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {qcType === "PHYSICAL" && "Physical Verification"}
          {qcType === "SPECIFICATION" && "Specification Check"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* -------- GRN INFO -------- */}
        <Row className="mb-3">
          
          <Col md={3}>
          <strong>Material Code :</strong> {rowData?.materialCode}
          </Col>
          <Col md={3}>
            <strong>Material :</strong> {rowData?.materialDescription}
          </Col>
          
        </Row>

        {/* -------- PHYSICAL VERIFICATION -------- */}
        {qcType === "PHYSICAL" && (
          <>
            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Packaging Condition"
                  name="packagingCondition"
                  value={qcForm.packagingCondition}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Physical Damage"
                  name="physicalDamage"
                  value={qcForm.physicalDamage}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Quantity Verified"
                  name="quantityVerified"
                  value={qcForm.quantityVerified}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Inspection Remarks"
                  name="inspectionRemarks"
                  value={qcForm.inspectionRemarks}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
            </Row>
          </>
        )}

        {/* -------- SPECIFICATION CHECK -------- */}
        {qcType === "SPECIFICATION" && (
          <>
            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Model Matches PO"
                  name="modelMatch"
                  value={qcForm.modelMatch}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Brand Matches PO"
                  name="brandMatch"
                  value={qcForm.brandMatch}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Size / Grade Match"
                  name="sizeGradeMatch"
                  value={qcForm.sizeGradeMatch}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Technical Parameters OK"
                  name="technicalParamsOk"
                  value={qcForm.technicalParamsOk}
                  onChange={handleChange}
                  disabled={true}
                />
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {editMode ? "Close" : "Cancel"}
        </Button>
        {/* {!editMode && (
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        )} */}
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialListQualityCheckModal;
